import React, { useLayoutEffect, useRef, useState } from 'react';
import cn from 'classnames';

import AvatarUser from '../../common/UI/AvatarUser';
import styles from '../gantt.less';

const MIN_LABEL_WIDTH = 120;

const stopDrag = (event) => event.stopPropagation();

const TaskLabel = ({ data }) => {
  const textRef = useRef(null);
  const [outside, setOutside] = useState(false);

  useLayoutEffect(() => {
    const text = textRef.current;
    const checkFit = () => setOutside(data.$w < MIN_LABEL_WIDTH && text.scrollWidth > text.clientWidth);
    checkFit();

    const observer = new ResizeObserver(checkFit);
    observer.observe(text);
    return () => observer.disconnect();
  }, [data.text, data.$w]);

  return (
    <>
      <div className="wx-content">
        <span ref={textRef} className={cn(styles.taskText, { [styles.taskTextHidden]: outside })}>
          {data.text}
        </span>
      </div>
      {(outside || data.employees?.length > 0) && (
        <div className={styles.taskAfter} onMouseDown={stopDrag} onTouchStart={stopDrag}>
          {data.employees?.length > 0 && (
            <span className={styles.taskAvatars}>
              {data.employees.map((employee) => (
                <span key={employee.id} className={styles.taskAvatar} data-employee-name={employee.title}>
                  <AvatarUser userName={employee.title} size={20} />
                </span>
              ))}
            </span>
          )}
          {outside && <span className={styles.shortTaskText}>{data.text}</span>}
        </div>
      )}
    </>
  );
};

export default TaskLabel;
